import Cookies from 'cookies-js';
import axios from 'axios';
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_ERROR,
    USER_PROFILE_CHANGE,
    USER_LOGOUT,
    USER_INIT,
    USER_SET,
} from "../actions/profileActions";

const initialState = {
    isAuth: false,
    fetching: false,
    error: false,
    errorText: "",
    accessToken: "",
    userName: "",
    roles: [],
    backUrl: "/",
}

const access_token = "access_token";
const userName = "userName";

export default function profile(state = initialState, action) {
    let response = action.payload;
    let cookieUserName = Cookies.get(userName);
    let accessToken = Cookies.get(access_token);
    switch (action.type) {
        case USER_PROFILE_CHANGE:
            return { ...state, [action.payload.name]: action.payload.value }
        case USER_LOGIN_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case USER_LOGIN_SUCCESS:

            Cookies.set(access_token, response.access_token, { path: "/", expires: response.expires_in });
            Cookies.set(userName, response.userName, { path: "/", expires: response.expires_in });

            return {
                ...initialState,
                backUrl:state.backUrl,
                isAuth: true,
                accessToken: response.access_token,
            }
        case USER_LOGIN_ERROR:
            return {
                ...state,
                fetching: false,
                error: true,
                errorText: action.payload
            }
        case USER_LOGOUT:
            Cookies.set(access_token);
            Cookies.set(userName);
            return {
                ...initialState,
                backUrl: action.payload.backUrl ? action.payload.backUrl : initialState.backUrl
            };
        case USER_INIT:
            axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
            return {
                ...state,
                userName: cookieUserName ? cookieUserName : state.username,
                isAuth:true
            }
        case USER_SET:
            return {
                ...state,
                userName: action.payload.Name ? action.payload.Name : action.payload.Email,
                role: action.payload.Role,
                isAuth: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profile.js